<template>
    <div class="flex flex-col">
        <LiquorTree :ref="tree" :data="treeData" :options="treeOptions" @node:selected="onNodeSelected" />
        <div class="flex items-center w-full">
            <span class="cursor-pointer">
                <input type="checkbox" :id="options.value" :value="options.value" :checked="options.selected"
                    v-model="selectAll" @change="handleChange" class="form-checkbox h-5 w-5 text-blue-500" />
                <label class="ml-2" @click="handleLabelClick(options)">
                    {{ options.label }}
                    <span v-if="options.children">
                        [{{ options.expanded ? '-' : '+' }}]
                    </span>
                </label>
            </span>
        </div>
        <div v-if="options.expanded && options.children" class="ml-6 mt-2">
            <div v-for="(cOption, cIndex) in options.children" :key="cIndex">
                <div class="flex items-center w-full">
                    <label class="ml-2">
                        <input :value="cOption.value" v-model="selected" :sector="cOption.value" type="checkbox">
                        {{ cOption.label }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import LiquorTree from 'liquor-tree'

export default {
    components: [
        LiquorTree,
    ],
    props: {
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    emits: ["onBox"],
    data() {
        return {
            treeData: [
                { text: 'Item 1' },
                {
                    text: 'Item 2', state: { expanded: true }, children: [
                        { text: 'Item 2.1' },
                        { text: 'Item 2.2' },
                        { text: 'Item 2.3' }
                    ]
                },
                { text: 'Item 3', state: { selected: true } },
                { text: 'Item 4' }
            ],
            treeOptions: {
                miltiple: false
            },
            dataModel: [
                {
                    id: "1",
                    label: "一级 1",
                    children: [
                        {
                            id: "11",
                            label: "二级 1-1",
                        },
                        {
                            id: "12",
                            label: "二级 1-2",
                        },
                    ]
                },
                {
                    label: "一级 2",
                    id: "11",
                    children: [
                        {
                            label: "二级 2-1",
                            id: "12",
                            children: []
                        },
                        {
                            label: "二级 2-2",
                            id: "15",
                            children: []
                        }
                    ]
                }
            ],
            selected: this.value,
        };
    },
    methods: {
        handleChange() {
            this.$emit('onBox:selected', this.selected);
        },

        handleAccordionChange(option) {
            option.expanded = !option.expanded;
        },
        handleLabelClick(option) {
            if (option.children) {
                this.handleAccordionChange(option);
            }
        },

        onNodeSelected(node) {
            alert(node)
        }
    },
    computed: {
        selectAll: {
            get() {
                return this.selected.length === this.options.children.length
            },
            set(value) {
                this.selected = []

                if (value) {
                    console.log(value);
                    this.options.children.forEach((select) => {
                        this.selected.push(select.value)
                    });
                }
            }
        }, // END selectAll
    }
};
</script>